import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    httpClient: any;
    constructor(private http: HttpClient) {}

    // Get Alert List
    getAlerts(filters?) {
        let params = new HttpParams();
        
        if(filters) {
            params = params.set('read', filters.read);
            params = params.set('page', filters.page);
        } else {
            params = params.set('read', 0);
        }
        
        return this.http.get<Array<Object>>(
            `${environment.api_url}/alerts`, {
                params: params
            }
        );
    }

    // Set Alert Status
    setAlertStatus(id) {
        return this.http.post<Object>(
            `${environment.api_url}/alert/${id}/read`, {}
        );
    }
    updateConversationTimestamp(id:number){
        return this.http.post<Object>(`${environment.api_url}/conversation/update_timestamp/${id}`, {});
    }
}
